import { render, staticRenderFns } from "./SkillItem.vue?vue&type=template&id=7a8d2d6a&"
import script from "./SkillItem.vue?vue&type=script&lang=js&"
export * from "./SkillItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports